import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';
import Icon from '../Icon/Icon.js';

var GLOBETROTTER = siteThemes.GLOBETROTTER,
  DEFAULT = siteThemes.DEFAULT;
var fillColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '--color-teal-800'), GLOBETROTTER, '--color-black'));
var fillColorDone = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '--color-teal-800'), GLOBETROTTER, '--color-white'));
var textColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '--color-grey-600'), GLOBETROTTER, '--color-black'));
var borderColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '--color-grey-300'), GLOBETROTTER, '--color-black'));
var borderWidth = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '3px'), GLOBETROTTER, '1px'));
var styledIcon = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '--color-white'), GLOBETROTTER, '--color-black'));
var lineHeight = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '3px'), GLOBETROTTER, '1px'));
var childrenFontWidth = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'bold'), GLOBETROTTER, 'normal'));
var ProgressIndicator = styled.ul.withConfig({
  displayName: "style__ProgressIndicator",
  componentId: "sc-1dvqsn4-0"
})(["display:flex;justify-content:space-between;align-items:stretch;"]);
var Step = styled.li.withConfig({
  displayName: "style__Step",
  componentId: "sc-1dvqsn4-1"
})(["display:flex;flex-direction:column;flex-shrink:0;align-items:center;position:relative;flex:1 1 0%;"]);
var StepTopContainer = styled.div.withConfig({
  displayName: "style__StepTopContainer",
  componentId: "sc-1dvqsn4-2"
})(["height:36px;display:flex;align-items:center;"]);
var StepCircle = styled.span.withConfig({
  displayName: "style__StepCircle",
  componentId: "sc-1dvqsn4-3"
})(["display:flex;justify-content:center;align-items:center;color:var(--color-grey-600);border-radius:50%;z-index:2;", " ", ""], function (_ref) {
  var $type = _ref.$type;
  if ($type === 'done') {
    return css(["background:var(", ");border:1px solid var(", ");"], fillColorDone, fillColor);
  }
  if ($type === 'active') {
    return css(["background:white;border:14px solid var(", ");"], fillColor);
  }
  return css(["background:var(--color-white);border:", " solid var(", ");"], borderWidth, borderColor);
}, function (props) {
  if (props.$isLastStep && !props.$showDotsLast) {
    return css(["width:16px;height:16px;"]);
  }
  return css(["height:36px;width:36px;"]);
});
var StyledIcon = styled(Icon).withConfig({
  displayName: "style__StyledIcon",
  componentId: "sc-1dvqsn4-4"
})(["fill:var(", ");"], styledIcon);
var StepChildren = styled.span.withConfig({
  displayName: "style__StepChildren",
  componentId: "sc-1dvqsn4-5"
})(["color:var(", ");margin-top:var(--space-200);font-size:1.4rem;text-align:center;display:none;", " ", ""], textColor, function (props) {
  return props.$type === 'active' && css(["display:block;font-weight:", ";"], childrenFontWidth);
}, mq.s(css(["display:block;"])));
var ProgressLine = styled.span.withConfig({
  displayName: "style__ProgressLine",
  componentId: "sc-1dvqsn4-6"
})(["position:absolute;top:17px;left:calc(50%);right:calc(-50%);z-index:1;background:", ";height:", ";"], function (props) {
  return props.$shouldFill ? css(["var(", ")"], fillColor) : 'var(--color-grey-300)';
}, lineHeight);
var DotsContainer = styled.div.withConfig({
  displayName: "style__DotsContainer",
  componentId: "sc-1dvqsn4-7"
})(["position:absolute;display:flex;justify-content:space-between;width:24px;top:17px;left:calc(50% + 24px);"]);
var Dot = styled.div.withConfig({
  displayName: "style__Dot",
  componentId: "sc-1dvqsn4-8"
})(["width:4px;height:4px;border-radius:50%;background:var(--color-grey-300);"]);

export { Dot, DotsContainer, ProgressIndicator, ProgressLine, Step, StepChildren, StepCircle, StepTopContainer, StyledIcon };
//# sourceMappingURL=style.js.map
